import { render, staticRenderFns } from "./WolfLegend.vue?vue&type=template&id=7f84845b&scoped=true&"
import script from "./WolfLegend.vue?vue&type=script&lang=js&"
export * from "./WolfLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f84845b",
  null
  
)

export default component.exports